module.exports = __webpack_public_path__ + "img/4.e39b7dac.png";